import { useTranslation } from 'react-i18next'
import styles from './ComingSoonPage.module.less'

function ComingSoonPage() {
  const { t } = useTranslation()

  return (
    <div className={styles.comingSoonPage} data-testid='coming-soon-page'>
      <div className={styles.card}>
        <p className={styles.title}>{t('productSwitch.common.comingSoon')}</p>
      </div>
    </div>
  )
}

export default ComingSoonPage
